import React from 'react';
import { View, StyleSheet, ScrollView, Pressable } from 'react-native';
import { Card, Text } from '@constants/Themed';
import { H4, Paragraph } from 'tamagui';
import { HIDE_LOADING_MODAL } from '@reduxLocal/actions/types';
import { useDispatch } from 'react-redux';

interface SheetSelectorModalProps {
  showSheetSelector: boolean;
  availableSheets: string[];
  theme: boolean;
  onSelectSheet: (sheetName: string) => void;
  onCancel: () => void;
}

export const SheetSelectorModal: React.FC<SheetSelectorModalProps> = ({
  showSheetSelector,
  availableSheets,
  theme,
  onSelectSheet,
  onCancel,
}) => {
  const dispatch = useDispatch();

  if (!showSheetSelector) return null;

  return (
    <View style={{
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0,0,0,0.5)',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 1000
    }}>
      <Card style={{
        backgroundColor: theme ? 'white' : '#1e293b',
        padding: 30,
        borderRadius: 15,
        maxWidth: 400,
        width: '90%',
        maxHeight: 500
      }}>
        <H4 style={{ textAlign: 'center', marginBottom: 20, color: theme ? '#2563eb' : '#60a5fa' }}>
          Select Sheet to Import
        </H4>
        <Paragraph style={{ textAlign: 'center', marginBottom: 25, color: theme ? '#6b7280' : '#9ca3af' }}>
          This Excel file contains multiple sheets. Please select which sheet you'd like to import:
        </Paragraph>

        <ScrollView style={{ maxHeight: 250 }}>
          {availableSheets.map((sheetName, index) => (
            <Pressable
              key={index}
              onPress={() => onSelectSheet(sheetName)}
              style={{
                padding: 15,
                borderRadius: 8,
                backgroundColor: theme ? '#f8fafc' : '#334155',
                marginBottom: 10,
                borderColor: theme ? '#e2e8f0' : '#475569'
              }}
            >
              <Text style={{ fontSize: 16, fontWeight: '500', color: theme ? '#1e293b' : '#e2e8f0' }}>
                📊 {sheetName}
              </Text>
            </Pressable>
          ))}
        </ScrollView>

        <Pressable
          onPress={() => {
            onCancel();
            dispatch({ type: HIDE_LOADING_MODAL });
          }}
          style={{
            marginTop: 20,
            padding: 12,
            borderRadius: 8,
            backgroundColor: '#ef4444',
            alignItems: 'center'
          }}
        >
          <Text style={{ color: 'white', fontWeight: '600' }}>Cancel</Text>
        </Pressable>
      </Card>
    </View>
  );
};




